import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';
import { Link } from 'react-router-dom';

import DepositIcon from '@/assets/icons/deposit-icon.svg?react';
import SendIcon from '@/assets/icons/send-icon.svg?react';
import WithdrawIcon from '@/assets/icons/withdraw-icon.svg?react';
import { EmptyState } from '@/components/atoms/EmptyState';
import { usePermissionsManager } from '@/hooks/usePermissionsManager';
import { useTranslator } from '@/hooks/useTranslator';
import { Permission } from '@/types/permissions';

interface LinkItem {
  readonly key: string;
  readonly path: string;
  readonly label: string;
  readonly icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

export const NoActivityView: React.FC = (): React.ReactElement => {
  const { userIsAuthorizedTo } = usePermissionsManager();
  const tr = useTranslator();

  return (
    <EmptyState.Container>
      <EmptyState.Title>{tr('NO_ACTIVITY_YET_TITLE')}</EmptyState.Title>
      <EmptyState.Message>{tr('NO_ACTIVITY_YET_SUBTITLE')}</EmptyState.Message>
      <EmptyState.Actions sx={{ mt: 4 }}>
        {userIsAuthorizedTo(Permission.CREATE_TRANSACTIONS) &&
          links.map((link: LinkItem): React.ReactElement => {
            const Icon = link.icon;

            return (
              <ButtonBase key={link.key} component={Link} to={link.path} sx={styles.button}>
                <Box sx={styles.buttonIcon}>
                  <Icon style={iconStyle} stroke="currentColor" />
                </Box>
                <Typography variant="h8">{tr(link.label)}</Typography>
              </ButtonBase>
            );
          })}
      </EmptyState.Actions>
    </EmptyState.Container>
  );
};

const links = [
  {
    key: 'transfer',
    path: '/home/transfer',
    label: 'Transfer',
    icon: SendIcon,
  },
  {
    key: 'deposit',
    path: '/home/deposit',
    label: 'Deposit',
    icon: DepositIcon,
  },
  {
    key: 'withdrawal',
    path: '/home/withdraw',
    label: 'Withdraw',
    icon: WithdrawIcon,
  },
];

const iconStyle = {
  width: 12,
  height: 12,
};

const styles: Record<string, SystemStyleObject> = {
  buttonIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
    height: 24,
    borderRadius: 4,
    backgroundColor: 'custom.White',
    color: 'text.primary',
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    width: 141,
    height: 48,
    lineHeight: '48px',
    backgroundColor: 'custom.InputsBackground',
    borderRadius: 4,
  },
};
